export default "__VITE_PUBLIC_ASSET__548fc15a__"